(() => {
  'use strict';
  const root = document.documentElement;
  const visible = el => Boolean(el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && getComputedStyle(el).display !== 'none');
  let privacyVisible = false;
  const syncPrivacy = () => {
    privacyVisible = ['shopify-pc__banner', 'shopify-pc__prefs__dialog'].some(id => visible(document.getElementById(id)));
    root.classList.toggle('rc-privacy-visible', privacyVisible);
    const offer = document.getElementById('RcWelcomeOffer');
    if (privacyVisible && offer?.open) offer.close();
  };
  const privacyObserver = new MutationObserver(syncPrivacy);
  privacyObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open'] });
  syncPrivacy();
  const dialog = document.getElementById('RcWelcomeOffer');
  if (!dialog || !dialog.showModal) return;
  let opener;
  let automaticallyShown = false;
  let engaged = false;
  let elapsed = false;
  let cooldown = false;
  const storageKey = 'rc_offer_dismissed';
  try { automaticallyShown = sessionStorage.getItem('rc_offer_seen') === '1'; } catch (_) {}
  // Local display preference only; no identifiers, pixels or marketing consent.
  try { cooldown = Date.now() - Number(localStorage.getItem(storageKey) || 0) < 7 * 86400000; } catch (_) { /* In-memory frequency cap remains. */ }
  const busy = () => privacyVisible || Boolean(document.querySelector('dialog[open], form[aria-busy="true"], [data-add-button][disabled][aria-busy="true"]'));
  const inputFocused = () => Boolean(document.activeElement?.closest('input, select, textarea, [contenteditable="true"]'));
  const dismiss = () => {
    if (!dialog.open) return;
    dialog.close();
    cooldown = true;
    try { localStorage.setItem(storageKey, String(Date.now())); } catch (_) { /* Storage can be unavailable. */ }
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  };
  const open = manual => {
    if (busy() || inputFocused() || (!manual && (document.visibilityState !== 'visible' || cooldown || automaticallyShown || !engaged || !elapsed))) return false;
    opener = document.activeElement;
    dialog.showModal();
    dialog.querySelector('[data-offer-close]')?.focus({ preventScroll: true });
    automaticallyShown = true;
    try { sessionStorage.setItem('rc_offer_seen', '1'); } catch (_) {}
    return true;
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('.rc-offer-trigger');
    if (trigger && open(true)) event.preventDefault();
    if (event.target.closest('[data-offer-close]')) dismiss();
  });
  dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const controls = [...dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary')].filter(visible);
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (!first) return;
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dismiss();
  });
  dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus({ preventScroll: true }); });
  if (dialog.querySelector('[data-rc-signup-success]')) { cooldown = true; try { localStorage.setItem(storageKey, String(Date.now())); } catch (_) {} }
  if (dialog.dataset.autoOffer !== 'true' || cooldown || /\/(cart|checkout|account)(\/|$)/.test(location.pathname)) return;
  const desktop = () => matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
  window.addEventListener('scroll', () => { if (window.scrollY > Math.min(400, innerHeight * .6)) engaged = true; }, { passive: true });
  const delay = Math.max(30, Number(dialog.dataset.offerDelay) || 45) * 1000;
  window.setTimeout(() => { elapsed = true; if (desktop()) open(false); }, delay);
  document.addEventListener('pointerout', event => {
    if (desktop() && event.pointerType === 'mouse' && event.relatedTarget === null && event.clientY <= 0) open(false);
  });
})();
